import {ProductCreate, ProductResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class ProductApi extends CrudApiAbstract<
  ProductResource,
  ProductCreate
> {
  public constructor() {
    super(`${ResourceType.Product}s`);
  }
}
